// project-imports
import tickets from './tickets';
import administration from './administration';
import storeOperations from './storeOperations';
import traders from './traders';
import storeIncentives from './storeIncentives';
import { clusterwiseIncentives, slabwiseIncentives } from './staffIncentives';

// ==============================|| MENU ITEMS ||============================== //

// The dashboard group is spliced in at index 0 by the Navigation component
// (from `menu-items/dashboard.js`). Tickets follows directly after Dashboard so
// the per-workflow screens read as primary navigation, then the administration
// group (user accounts + store directory) and the store operations group
// (workflow definitions + violations).
const menuItems = {
  items: [tickets, administration, storeOperations, traders, storeIncentives, clusterwiseIncentives, slabwiseIncentives],
};

export default menuItems;
